import { addDays } from "date-fns/addDays";

import { EventTime } from "@ctrl/controller-rpc";

import { getMinimumEventEnd } from "./get-minimum-event-end";

export const buildEventTime = (
  allDay: boolean,
  start: Date,
  end: Date | null
): EventTime => {
  if (allDay) {
    if (!end)
      // Single-day event
      return { date: start };

    // Multi-day event
    // HACK: FullCalendar returns event.end as 03/01 00:00:00
    // to let us know that the event includes all the 02/01
    // and because our backend expects the real end date then we have
    // to remove 1 day to the given event.end date.
    const end_date = addDays(end, -1);
    return { start_date: start, end_date };
  }

  return {
    start_time: start,
    end_time: end ? end : getMinimumEventEnd(start),
  };
};
